/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LearningDomainInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearningDomainApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'LearningDomains');
  }

  find(params?: Record<string, any>): Observable<LearningDomainInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<LearningDomainInterface[]>(path, httpParams);
  }

  public getLearningDomains(params: HttpParams): Observable<{ count: number; results: LearningDomainInterface[] }> {
    return this.get('search', params);
  }

  public createLearningDomain(learningDomain: LearningDomainInterface): Observable<LearningDomainInterface> {
    return this.post(null, null, learningDomain);
  }

  public updateLearningDomain(
    params: HttpParams,
    learningDomain: LearningDomainInterface
  ): Observable<LearningDomainInterface> {
    return this.put(null, params, learningDomain);
  }

  public deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(map(() => true));
  }
}
